export default __webpack_public_path__ + "static/media/camera.3787da06.png";